<template>
  <div class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light" style="background-image: linear-gradient(to right, rgb(68,68,68), rgb(24,31,40)); border-color: rgb(24,31,40)"
       @mouseenter="$sidebar.onMouseEnter()"
       @mouseleave="$sidebar.onMouseLeave()"
       :data="backgroundColor">
    <div class="scrollbar-inner" ref="sidebarScrollArea">
      <div class="sidenav-header d-flex align-items-center text-center">
        <a href="/home">
          <img src="@/assets/logo_sistema_sem_fundo.png" class="logoMenu" alt="VigiPlanner">
        </a>
        <div class="ml-auto">
          <!-- Sidenav toggler -->
          <div class="sidenav-toggler d-none d-xl-block"
               :class="{'active': !$sidebar.isMinimized }"
               @click="minimizeSidebar">
            <div class="sidenav-toggler-inner text-ligh">
              <i class="sidenav-toggler-line text-ligh" ></i>
              <i class="sidenav-toggler-line text-ligh"></i>
              <i class="sidenav-toggler-line text-ligh"></i>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
      <div class="navbar-inner">
        <ul class="navbar-nav">
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              >
              </sidebar-item>
            </sidebar-item>
          </slot>
        </ul>
        <slot name="links-after"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      description: 'Sidebar short title'
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
        sidebarLinks : null,
        backgroundColor: null
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
.logoMenu  {
  width: 50%;
}
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
